import {register} from '../vendor/theme-scripts/theme-sections';
import slideDown from '../util/slide-down';
import hideElement from '../util/hide-element';

const selectors = {
  loginToggle: '#AdminLoginToggle',
  newsletterToggle: '#NewsletterToggle',
  login: '#AdminLogin',
  signup: '#CustomerSignup',
  errors: '.errors',
  contactErrors: '#contact_form .errors',
  loginErrors: '#login_form .errors',
};

class Password {
  constructor(section) {
    this.container = section.container;
    this.loginToggle = this.container.querySelector(selectors.loginToggle);
    this.newsletterToggle = this.container.querySelector(selectors.newsletterToggle);
    this.login = this.container.querySelector(selectors.login);
    this.signup = this.container.querySelector(selectors.signup);
    this.errors = this.container.querySelector(selectors.errors);
    this.contactErrors = this.container.querySelector(selectors.contactErrors);
    this.loginErrors = this.container.querySelector(selectors.loginErrors);
    this.init();
  }

  init() {
    this.loginToggle.addEventListener('click', (e) => {
      e.preventDefault();
      slideDown(this.login);
      hideElement(this.signup);
      if (this.errors) {
        hideElement(this.errors);
      }
    });

    this.newsletterToggle.addEventListener('click', (e) => {
      e.preventDefault();
      hideElement(this.login);
      slideDown(this.signup);
      if (this.errors) {
        hideElement(this.errors);
      }
    });

    if (this.contactErrors) {
      hideElement(this.login);
      slideDown(this.signup);
    }

    if (this.loginErrors) {
      slideDown(this.login);
      hideElement(this.signup);
    }
  }
}

const passwordSection = {
  onLoad() {
    new Password(this);
  },
};

register('password-template', passwordSection);
